import { type FlexProps, Flex } from '../flex';
import { ErrorIcon } from '../icons';
import { Text } from '../text';

type ErrorBoxProps = {
  message?: string;
} & FlexProps;

/**
 * @deprecated
 **/
function ErrorBox(props: Readonly<ErrorBoxProps>) {
  const { message = 'เกิดข้อผิดพลาด', ...restProps } = props;

  return (
    <Flex
      sx={(theme) => ({
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: 1,
        p: {
          xs: theme.spacing(4),
          md: theme.spacing(8),
        },
      })}
      {...restProps}
    >
      <ErrorIcon fontSize='large' color='error' />
      <Text>{message}</Text>
    </Flex>
  );
}

export { ErrorBox };
